import { render, staticRenderFns } from "./ListCheckGroup.vue?vue&type=template&id=1c8fb4d7&scoped=true"
import script from "./ListCheckGroup.vue?vue&type=script&lang=js"
export * from "./ListCheckGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8fb4d7",
  null
  
)

export default component.exports